let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kxSRI")).then(() => parcelRequire('ikW1t'));